import {AppFunction} from "../misc/types";
import View from "../framework/view";
import {UsersView} from "../views/users";

export class UsersFunction extends AppFunction {

    readonly v : View;

    constructor() {
        super();
        this.v = new UsersView();
    }

    view() {
        return this.v;
    }

    url() {
        return `/users`;
    }
}
